"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const optimizer_1 = require("../node-visitor/optimizer");
class TwingExtensionOptimizer extends extension_1.TwingExtension {
    constructor(optimizers = -1) {
        super();
        this.optimizers = optimizers;
    }
    getNodeVisitors() {
        return [
            new optimizer_1.TwingNodeVisitorOptimizer(this.optimizers)
        ];
    }
}
exports.TwingExtensionOptimizer = TwingExtensionOptimizer;
